import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import discussion1image1 from '../../documents/discussion1image1.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Discussion1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            discussion1Key: ['	Effect of supplementary cementitious material on early age performance',
           ' Combined effect of light weight fine aggregate and slag on early age performance',
          	'Qualitative difference between the two mix proportions', 
            '	Effect of environmental conditionon early age behaviour of concrete bridge decks',
            '	Recommendationof indirect tensile strength tests for determination of early-age tensile strength'],
            discussion1Value: ['Ideas for future research', 'Independent Research','Philosophical Development'],
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Discussion & Closure of “Early-Age Behavior of Internally Cured Concrete Bridge Deck under Environmental Loading” by Waleed K. Hamid, Eric P. Steinberg, Ali A. Semendary, Issam Khoury, and Kenneth Walsh</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Duration: July – September 2020</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                <EuiText>
                        <b>Key Highlights</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.discussion1Key && this.state.discussion1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.discussion1Value && this.state.discussion1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'><EuiImage size='l' src={discussion1image1} />
                <EuiSpacer size='s'/>
                Significant Difference Between IC
                          and CC Mix at Various Ages</EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Discussion1 }